// extracted by mini-css-extract-plugin
export default {"data_box":"index_data_box_SQqN7","price":"index_price_vGM0I","green":"index_green_1xzbn","up":"index_up_-LsBc","down":"index_down_dTc8p"};